import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-table-sort',
  templateUrl: './table-sort.component.html',
  styleUrls: ['./table-sort.component.css'],
  imports: [CommonModule, RouterModule],
})
export class TableSortComponent implements OnInit {
  @Input() deselected: boolean = true;
  @Output() sorting = new EventEmitter<any>();
  descActive: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  sortAction(sortDescending: boolean): void {
    this.deselected = false;
    this.descActive = sortDescending;
    this.sorting.emit(sortDescending);
  }
}
